const IconFirstStep = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="102.598"
      height="89.431"
      viewBox="0 0 102.598 89.431"
    >
      <g id="undraw_add_files_re_v09g" transform="translate(4.441 -0.006)">
        <path
          id="Trazado_624"
          data-name="Trazado 624"
          d="M170.451,220.908a4.386,4.386,0,0,0-3.1,2.909c-.406,1.656.53,3.326.665,5.026.437,5.572-7.49,9.5-6.359,14.976.449,2.176,2.264,3.777,4.052,5.1,2.865,2.112,6.043,3.978,9.563,4.5,5.342.8,10.924-1.552,16.117-.065,4.188,1.2,7.393,4.715,11.553,6.012,3.166.988,6.577.6,9.867.2a10.393,10.393,0,0,0,5.063-1.528c2.661-1.981,2.828-5.893,4.61-8.7,2.752-4.324,8.785-5.173,13.843-4.332s9.971,2.909,15.1,2.74a6.89,6.89,0,0,0,3.173-.723,7.872,7.872,0,0,0,2.641-2.942,47.609,47.609,0,0,0,6.9-23.657,8.492,8.492,0,0,0-.7-4.2,7.677,7.677,0,0,0-4.258-3.207c-4.079-1.552-8.584-1.806-12.581-3.556-3.855-1.688-6.977-4.65-10.333-7.187a55.042,55.042,0,0,0-22.67-10.1,14.372,14.372,0,0,0-5.845-.208,13.853,13.853,0,0,0-5.82,3.352c-4.551,3.94-8.2,8.8-12.392,13.119a70.553,70.553,0,0,1-9.414,8.118,34.307,34.307,0,0,1-4.931,3.274C173.61,220.594,172.125,220.4,170.451,220.908Z"
          transform="translate(-165.984 -182.323)"
          fill="#85c440"
          opacity="0.2"
        />
        <path
          id="Trazado_505"
          data-name="Trazado 505"
          d="M259.8,99.259l-3.228.833-39.774,10.257-3.228.833a6.112,6.112,0,0,0-4.388,7.437l14,54.285a6.112,6.112,0,0,0,7.437,4.388l.008,0,46.214-11.918.008,0a6.112,6.112,0,0,0,4.388-7.437l-14-54.285A6.112,6.112,0,0,0,259.8,99.259Z"
          transform="translate(-210.044 -99.06)"
          fill="#f2f2f2"
        />
        <path
          id="Trazado_506"
          data-name="Trazado 506"
          d="M272.331,113.058l-3.824.986-38.583,9.95-3.824.986a4.353,4.353,0,0,0-3.124,5.3l14,54.285a4.353,4.353,0,0,0,5.3,3.124l.008,0,46.214-11.918.008,0a4.353,4.353,0,0,0,3.124-5.3l-14-54.285A4.353,4.353,0,0,0,272.331,113.058Z"
          transform="translate(-222.141 -111.156)"
          fill="#fff"
        />
        <path
          id="Trazado_507"
          data-name="Trazado 507"
          d="M420.549,238.788l-23.379,6.029a1.017,1.017,0,1,1-.508-1.969l23.379-6.029a1.017,1.017,0,0,1,.508,1.969Z"
          transform="translate(-373.246 -219.309)"
          fill="#f2f2f2"
        />
        <path
          id="Trazado_508"
          data-name="Trazado 508"
          d="M431.364,256.724l-27.44,7.076a1.017,1.017,0,0,1-.508-1.969l27.44-7.076a1.017,1.017,0,1,1,.508,1.969Z"
          transform="translate(-379.144 -234.969)"
          fill="#f2f2f2"
        />
        <path
          id="Trazado_509"
          data-name="Trazado 509"
          d="M450.817,356.162l-23.379,6.029a1.017,1.017,0,0,1-.508-1.969l23.379-6.029a1.017,1.017,0,0,1,.508,1.969Z"
          transform="translate(-399.675 -321.791)"
          fill="#f2f2f2"
        />
        <path
          id="Trazado_510"
          data-name="Trazado 510"
          d="M461.633,374.1l-27.44,7.076a1.017,1.017,0,0,1-.508-1.969l27.44-7.076a1.017,1.017,0,1,1,.508,1.969Z"
          transform="translate(-405.572 -337.451)"
          fill="#f2f2f2"
        />
        <path
          id="Trazado_511"
          data-name="Trazado 511"
          d="M481.086,473.535l-23.379,6.029a1.017,1.017,0,1,1-.508-1.969l23.379-6.029a1.017,1.017,0,0,1,.508,1.969Z"
          transform="translate(-426.103 -424.273)"
          fill="#f2f2f2"
        />
        <path
          id="Trazado_512"
          data-name="Trazado 512"
          d="M491.9,491.471l-27.44,7.076a1.017,1.017,0,1,1-.508-1.969l27.44-7.076a1.017,1.017,0,1,1,.508,1.969Z"
          transform="translate(-432 -439.934)"
          fill="#f2f2f2"
        />
        <path
          id="Trazado_513"
          data-name="Trazado 513"
          d="M300.256,291.521l-8.274,2.134a.488.488,0,0,1-.594-.35l-1.9-7.365a.488.488,0,0,1,.35-.594l8.273-2.134a.488.488,0,0,1,.594.35l1.9,7.365A.488.488,0,0,1,300.256,291.521Z"
          transform="translate(-280.323 -259.83)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_514"
          data-name="Trazado 514"
          d="M330.525,408.894l-8.273,2.134a.488.488,0,0,1-.594-.35l-1.9-7.365a.488.488,0,0,1,.35-.594l8.273-2.134a.488.488,0,0,1,.594.35l1.9,7.365A.488.488,0,0,1,330.525,408.894Z"
          transform="translate(-306.752 -362.313)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_515"
          data-name="Trazado 515"
          d="M360.793,526.268,352.52,528.4a.488.488,0,0,1-.594-.35l-1.9-7.365a.488.488,0,0,1,.35-.594l8.273-2.134a.488.488,0,0,1,.594.35l1.9,7.365A.488.488,0,0,1,360.793,526.268Z"
          transform="translate(-333.18 -464.795)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_516"
          data-name="Trazado 516"
          d="M493.042,209.052H445.3a6.113,6.113,0,0,0-6.106,6.106v56.06a6.112,6.112,0,0,0,6.106,6.106h47.743a6.112,6.112,0,0,0,6.106-6.106v-56.06a6.112,6.112,0,0,0-6.106-6.106Z"
          transform="translate(-411.047 -195.092)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_517"
          data-name="Trazado 517"
          d="M505.138,222.906H457.4a4.353,4.353,0,0,0-4.348,4.348v56.061a4.353,4.353,0,0,0,4.348,4.348h47.743a4.353,4.353,0,0,0,4.348-4.348V227.254a4.353,4.353,0,0,0-4.348-4.348Z"
          transform="translate(-423.144 -207.189)"
          fill="#fff"
        />
        <ellipse
          id="Elipse_5"
          data-name="Elipse 5"
          cx="11.023"
          cy="11.403"
          rx="11.023"
          ry="11.403"
          transform="translate(76.111 66.632)"
          fill="#85c440"
        />
        <path
          id="Trazado_519"
          data-name="Trazado 519"
          d="M633.845,451.721H609.7a1.017,1.017,0,0,1,0-2.034h24.143a1.017,1.017,0,1,1,0,2.034Z"
          transform="translate(-559.036 -405.198)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_520"
          data-name="Trazado 520"
          d="M638.039,478.768H609.7a1.017,1.017,0,0,1,0-2.034h28.338a1.017,1.017,0,1,1,0,2.033Z"
          transform="translate(-559.036 -428.814)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_521"
          data-name="Trazado 521"
          d="M633.845,572.934H609.7a1.017,1.017,0,0,1,0-2.034h24.143a1.017,1.017,0,1,1,0,2.034Z"
          transform="translate(-559.036 -511.033)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_522"
          data-name="Trazado 522"
          d="M638.039,599.982H609.7a1.017,1.017,0,0,1,0-2.034h28.338a1.017,1.017,0,1,1,0,2.034Z"
          transform="translate(-559.036 -534.65)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_523"
          data-name="Trazado 523"
          d="M511.913,445.989h-8.544a.488.488,0,0,1-.487-.487V437.9a.488.488,0,0,1,.487-.488h8.544a.488.488,0,0,1,.487.488V445.5A.488.488,0,0,1,511.913,445.989Z"
          transform="translate(-466.656 -394.478)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_524"
          data-name="Trazado 524"
          d="M511.913,567.2h-8.544a.488.488,0,0,1-.487-.488V559.11a.488.488,0,0,1,.487-.488h8.544a.488.488,0,0,1,.487.488v7.605A.488.488,0,0,1,511.913,567.2Z"
          transform="translate(-466.656 -500.313)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_525"
          data-name="Trazado 525"
          d="M677.713,316.786h-17.8a1.017,1.017,0,1,1,0-2.033h17.8a1.017,1.017,0,0,1,0,2.033Z"
          transform="translate(-602.877 -287.383)"
          fill="#ccc"
        />
        <path
          id="Trazado_526"
          data-name="Trazado 526"
          d="M681.907,343.834H659.913a1.017,1.017,0,1,1,0-2.034h21.994a1.017,1.017,0,0,1,0,2.034Z"
          transform="translate(-602.877 -310.999)"
          fill="#ccc"
        />
        <path
          id="Trazado_527"
          data-name="Trazado 527"
          d="M519.568,295.756h-16.41a.488.488,0,0,1-.487-.488V282.462a.488.488,0,0,1,.487-.488h16.41a.488.488,0,0,1,.488.488v12.807a.488.488,0,0,1-.488.488Z"
          transform="translate(-466.471 -258.763)"
          fill="#85c440"
        />
        <path
          id="Trazado_528"
          data-name="Trazado 528"
          d="M782.7,2034.647l3.325-3.8c.715-.817,1.425-1.639,2.15-2.447a.855.855,0,0,1,1.5.725,1.234,1.234,0,0,1-.264.492q-2.955,3.394-5.925,6.775a.879.879,0,0,1-1.439.051q-1.663-1.649-3.312-3.312a.874.874,0,1,1,1.223-1.231C780.863,2032.8,781.76,2033.7,782.7,2034.647Z"
          transform="translate(-696.869 -1954.015)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default IconFirstStep;
